<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <card class="stacked-form">
          <product-form v-if="product" @submit="submit" :init-product="product" :val-errors="valErrors"
            submit-text="Erstellen" />
        </card>
      </div>
    </div>
    <assign-to-supplier-dialog v-if="createdProduct" :show="showSupplierDialog" :suppliers="suppliers"
      @assignToSupplier="assignToSupplier" @close="closeSupplierDialog" :val-errors="assignErrors"
      :init-price="createdProduct.standard_price || ''" :init-referenznummer="createdProduct.referenznummer || ''" />
  </div>
</template>

<script>
import ProductForm from './product-form'
import AssignToSupplierDialog from './assign-to-supplier-dialog'
import swal from 'sweetalert2'

export default {
  components: { ProductForm, AssignToSupplierDialog },
  data() {
    return {
      suppliers: [],
      valErrors: [],
      product: null,
      showSupplierDialog: false,
      createdProduct: null,
      assignErrors: []
    }
  },
  methods: {
    async submit(product) {
      await this.initCsrf()

      const formData = new FormData();
      product.name ? formData.append('name', product.name) : null;
      product.short_name ? formData.append('short_name', product.short_name) : null;
      product.image ? formData.append('image', product.image) : null;
      product.barcode ? formData.append('barcode', product.barcode) : null;
      product.barcode_2 ? formData.append('barcode_2', product.barcode_2) : null
      product.hersteller ? formData.append('hersteller', product.hersteller) : null
      product.referenznummer ? formData.append('referenznummer', product.referenznummer) : null
      product.size ? formData.append('size', product.size) : null
      product.regal ? formData.append('regal', product.regal) : null
      product.regal_2 ? formData.append('regal_2', product.regal_2) : null
      product.comment ? formData.append('comment', product.comment) : null
      product.price ? formData.append('price', product.price) : null
      product.stk_pkg ? formData.append('stk_pkg', product.stk_pkg) : null
      product.has_ablaufdatum ? formData.append('has_ablaufdatum', product.has_ablaufdatum) : null
      product.kostennelle_req ? formData.append('kostennelle_req', product.kostennelle_req) : null
      product.storage_location ? formData.append('storage_location', product.storage_location) : null
      product.product_category_id ? formData.append('product_category_id', product.product_category_id) : null;
      product.standard_price ? formData.append('standard_price', product.standard_price) : null
      product.accounting_number ? formData.append('accounting_number', product.accounting_number) : null
      product.next_expiry_date ? formData.append('next_expiry_date', product.next_expiry_date) : null;
      product.pzn ? formData.append('pzn', product.pzn) : null;
      product.tax ? formData.append('tax', product.tax) : null;
      product.unit_id ? formData.append('unit_id', product.unit_id): null;
      this.valErrors = []
      try {
        const response = await this.$http.post('products', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        this.createdProduct = response.data;
        this.$notify({
          message: 'Produkt erfolgreich erstellt.',
          type: 'success'
        });
        this.showAlert();
      } catch ({response}) {
        this.valErrors = response.data.errors
        this.$notify({
          message: response.data.message,
          type:  'info'
        });
      }
    },
    showAlert(createdSupplier) {
      swal.fire({
        title: 'Lieferant',
        html: 'Wollen Sie jetzt das Produkt einem Lieferanten zuweisen?',
        confirmButtonText: 'Ja bitte!',
        showCancelButton: true,
        cancelButtonText: 'Nein danke!',
        timer: 3000,
        timerProgressBar: true,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-lg btn-fill btn-info',
        cancelButtonClass: 'btn btn-lg btn-fill btn-default'
      }).then((result) => {
        if (result.value === true) {
          this.showSupplierDialog = true
        } else {
          this.$router.push('/products')
        }
      })
    },
    async assignToSupplier(payload) {
      await this.initCsrf()

      const url = `/suppliers/${payload.supplier_id}/products/${this.createdProduct.id}`
      this.$http.post(url, { price: payload.price, referenznummer: payload.referenznummer }).then(({ data }) => {
        this.$notify({
          message: 'Produkt erfolgreich dem Lieferanten zugewiesen.',
          type: 'success'
        })
        this.closeSupplierDialog()
      }).catch(({ response }) => { this.assignErrors = response.data.errors })
    },
    closeSupplierDialog() {
      this.showSupplierDialog = false
      this.$router.push('/products')
    }
  },
  created() {
    const product = { price: '', standard_price: '', tax: 0.19, barcode: '', barcode_2: '' }
    if (this.$route.query.warehouse) {
      this.$http.get(`/warehouses/${this.$route.query.warehouse}`).then(({ data }) => {
        this.product.warehouse = data
      })
    }
    this.product = product

    this.$http.get('/suppliers').then(({ data }) => {
      this.suppliers = data
    })

  },
}
</script>

<style></style>
